import { render, staticRenderFns } from "./WExpandableCard.vue?vue&type=template&id=5e2a9a0d&scoped=true&"
import script from "./WExpandableCard.vue?vue&type=script&lang=ts&"
export * from "./WExpandableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a9a0d",
  null
  
)

export default component.exports